import React from 'react';
import { required, translate, ReferenceInput, AutocompleteInput } from 'react-admin';
import { parseLongText, formatLongText } from 'services/dataProvider';
import { selectLabel } from 'services/translations';
import { addErrorsNumberOfLinesForMultilanguageInput } from 'services/errorHandler';
import { withStyles } from '@material-ui/core';
import { containerStyles } from 'components/customFormStyle';
import MultiLanguageTextInput from 'components/MultiLanguageTextInput';

const MAX_NUMBER_OF_REALISATIONS = 5;
const MIN_NUMBER_OF_REALISATIONS = 3;

const MAX_NUMBER_OF_OBJECTIVES = 5;
const MIN_NUMBER_OF_OBJECTIVES = 3;

const MAX_NUMBER_OF_MISSIONS = 5;
const MIN_NUMBER_OF_MISSIONS = 3;

export const validateSellingPeersExperience = (translate: any) => (values: any) => {
  const errors: any = {};

  addErrorsNumberOfLinesForMultilanguageInput({
    errors,
    values,
    source: 'missions',
    minimum: MIN_NUMBER_OF_MISSIONS,
    maximum: MAX_NUMBER_OF_MISSIONS,
    messageKey: 'resources.experiences.fields.missions_limit_error',
    translate,
  });
  addErrorsNumberOfLinesForMultilanguageInput({
    errors,
    values,
    source: 'objectives',
    minimum: MIN_NUMBER_OF_OBJECTIVES,
    maximum: MAX_NUMBER_OF_OBJECTIVES,
    messageKey: 'resources.experiences.fields.objectives_limit_error',
    translate,
  });
  addErrorsNumberOfLinesForMultilanguageInput({
    errors,
    values,
    source: 'realisations',
    minimum: MIN_NUMBER_OF_REALISATIONS,
    maximum: MAX_NUMBER_OF_REALISATIONS,
    messageKey: 'resources.experiences.fields.realisations_limit_error',
    translate,
  });

  return errors;
};

export const SellingPeersInputs = translate(
  withStyles(containerStyles)(({ translate, classes, ...props }: any) => (
    <div className={classes.container}>
      <ReferenceInput
        {...props}
        source="activityArea.id"
        reference="activity-area"
        label={translate('resources.experiences.fields.activityArea.id')}
      >
        <AutocompleteInput optionText={selectLabel} />
      </ReferenceInput>

      <MultiLanguageTextInput
        isLongTextInput
        source="missions"
        rows={MAX_NUMBER_OF_MISSIONS}
        parse={parseLongText}
        format={formatLongText}
        validate={required()}
        placeholder="resources.experiences.placeholder.SellingPeers.missions"
        {...props}
      />
      <MultiLanguageTextInput
        isLongTextInput
        source="objectives"
        rows={MAX_NUMBER_OF_OBJECTIVES}
        parse={parseLongText}
        format={formatLongText}
        validate={required()}
        placeholder="resources.experiences.placeholder.SellingPeers.objectives"
        {...props}
      />
    </div>
  )),
);
